type Homepage = {
  type?: string | null;
  typeBeforeLinkInBio?: string | null;
  [key: string]: unknown;
};

export function toLinkInBioHomepage(homepage: Homepage | null | undefined): Homepage {
  const typeBeforeLinkInBio =
    homepage?.type === 'linkInBio' ? homepage.typeBeforeLinkInBio : homepage?.type;
  return { ...homepage, type: 'linkInBio', typeBeforeLinkInBio: typeBeforeLinkInBio ?? null };
}

export function fromLinkInBioHomepage(homepage: Homepage | null | undefined): Homepage {
  return {
    ...homepage,
    type: homepage?.typeBeforeLinkInBio ?? 'customerPortal',
    typeBeforeLinkInBio: null,
  };
}
